import { useSearchParams } from "next/navigation";

const DEFAULT_RETURN_TO = "/home";

const isValidReturnTo = (path: string | null): path is string => {
  if (!path) return false;
  return path.startsWith("/") && !path.includes("//") && !path.includes("\\");
};

export const useSafeReturnTo = () => {
  const searchParams = useSearchParams();
  const rawReturnTo = searchParams.get("returnTo");
  const hasValidReturnTo = isValidReturnTo(rawReturnTo);
  const returnTo = hasValidReturnTo ? rawReturnTo : DEFAULT_RETURN_TO;
  const returnToParam = hasValidReturnTo
    ? `?returnTo=${encodeURIComponent(rawReturnTo)}`
    : "";
  return { returnTo, returnToParam };
};
